import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import { Helmet, HelmetProvider } from 'react-helmet-async'; // Import both
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Works from './pages/Works';
import Blog from './pages/Blog';
import BlogSingle from './pages/BlogSingle';
import PortfolioSingle from './pages/PortfolioSingle';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './assets/css/main.css';
import './assets/fonts/icons/bootstrap-icons.min.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <>
        {/* Default Helmet (using the new import) */}
        <Helmet>
          <title>Franklin Fernandez | Full Stack Developer & Graphic Designer</title>
          <meta name="description" content="17+ years of experience in UI/UX, PHP, Laravel, and graphic design" />
          {/* Add other essential defaults */}
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>

        <Router>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/works" element={<Works />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogSingle />} />
            <Route path="/portfolio/:slug" element={<PortfolioSingle />} />
          </Routes>
          <Footer />
        </Router>
      </>
    </HelmetProvider>
  );
}

export default App;